import Header from '../../components/Header/Header';
import WhatsappFloatingButton from '../../components/WhatsappFloatingButton/WhatsappFloatingButton';
import Footer from '../../components/Footer/Footer';
import { FaqWrapper, FaqTitle, FaqSectionTitle, FaqQuestion, FaqAnswer } from './Faq.styled';


const Faq = () => {
  return (
    <>
      <Header />
      <FaqWrapper>
        <FaqTitle>
          Pertanyaan Umum (FAQ)
        </FaqTitle>
        <FaqSectionTitle>
          Tentang Produk Kami
        </FaqSectionTitle>
        <FaqQuestion>
          Bahan apa yang digunakan untuk cup plastik Anda? 
        </FaqQuestion>
        <FaqAnswer>
          Semua cup plastik kami terbuat dari virgin material PP (Polypropylene) berkualitas tinggi. PP dikenal karena fleksibilitasnya dan sifatnya yang aman untuk makanan.
        </FaqAnswer>
        <FaqQuestion>
          Apakah cup plastik PP Anda aman untuk makanan dan minuman? 
        </FaqQuestion>
        <FaqAnswer>
          Ya, semua cup plastik PP kami food-grade dan sangat aman untuk kontak langsung dengan makanan dan minuman. Kami memastikan bahwa produk kami memenuhi standar keamanan pangan yang berlaku.
        </FaqAnswer>
        <FaqQuestion>
          Berapa ukuran cup plastik PP yang tersedia? 
        </FaqQuestion>
        <FaqAnswer>
          Kami menyediakan berbagai ukuran cup plastik PP, mulai dari 12 oz hingga 24 oz. Silakan lihat halaman produk kami untuk daftar lengkap ukuran yang tersedia.
        </FaqAnswer>
        <FaqQuestion>
          Apakah cup plastik PP Anda tahan panas?
        </FaqQuestion>
        <FaqAnswer>
          Mohon diperhatikan, cup plastik PP kami tidak disarankan untuk cairan panas. Produk ini dirancang optimal untuk minuman dingin atau cairan dengan suhu ruang
        </FaqAnswer>
        <hr />

        <FaqSectionTitle>
          Pemesanan dan Pengiriman
        </FaqSectionTitle>
        <FaqQuestion>
          Bagaimana cara memesan cup plastik di website Anda? 
        </FaqQuestion>
        <FaqAnswer>
          Untuk memesan, silakan pilih produk yang Anda inginkan di website dan kirimkan permintaan quotation. Setelah itu, isi data diri Anda dan kami akan segera menghubungi Anda via WhatsApp untuk proses selanjutnya.
        </FaqAnswer>
        <FaqQuestion>
          Berapa minimum pemesanan? 
        </FaqQuestion>
        <FaqAnswer>
          Minimum pemesanan untuk cup plastik kami adalah <b>1 karton, yang berisi 1000 cup.</b>
        </FaqAnswer>
        <FaqQuestion>
          Apakah ada biaya pengiriman? 
        </FaqQuestion>
        <FaqAnswer>
          Kami menyediakan layanan <b>gratis pengiriman untuk wilayah Jabodetabek</b> dengan minimum pemesanan 220 karton. Untuk pesanan di bawah jumlah tersebut atau di luar Jabodetabek, biaya pengiriman akan disesuaikan.
        </FaqAnswer>
        <FaqQuestion>
          Berapa lama waktu pengiriman?
        </FaqQuestion>
        <FaqAnswer>
          Waktu pengiriman bervariasi tergantung lokasi Anda dan jumlah pesanan. Setelah Anda melakukan request quotation dan konfirmasi pesanan, tim kami akan memberikan estimasi waktu pengiriman.
        </FaqAnswer>
        <FaqQuestion>
          Bisakah saya melacak pesanan saya?
        </FaqQuestion>
        <FaqAnswer>
          Tim kami akan memberikan informasi mengenai status pengiriman pesanan Anda setelah proses konfirmasi.
        </FaqAnswer>
        <hr />

      </FaqWrapper>
      <Footer />
      <WhatsappFloatingButton />
    </>
  );
}

export default Faq;
